import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/Service/auth.service';
import { LoadingService } from 'src/app/Service/loading.service';

@Component({
    selector: 'app-verifyEmail',
    templateUrl: './verifyEmail.component.html',
    styleUrls: ['./verifyEmail.component.css'],
    standalone: false
})
export class VerifyEmailComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  constructor(
    public auth: AuthService,
    private router: Router,
    private loaderService: LoadingService
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.auth.userProfileSubject$.subscribe((resp) => {
        if (resp?.email_verified) {
          this.router.navigate(['user']);
        } else {
          this.loaderService.HideLoading();
        }
      })
    );
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  gotoDashBoard() {
    window.location.href = '/';
  }
}
